import classNames from 'classnames'

import type { InputHTMLAttributes, PropsWithChildren, ReactElement, ReactNode } from 'react'

import './styles.scss'

export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string
  error?: ReactNode
}

const Wrapper = ({ children, className, error }: PropsWithChildren<Props>): ReactElement => {
  return (
    <div className={classNames(className, 'rhf-input-wrapper')}>
      {children}
      {error ? <span className="rhf-input-wrapper__error">{error}</span> : null}
    </div>
  )
}

export default Wrapper
